import { connect } from "react-redux";
import * as Nested from "@/util/Nested";
import TransactionSearchPage from "./TransactionSearchPage";
import * as CriteriaForm from "./CriteriaForm.state";
import * as FiltersForm from "./FiltersForm.state";
import _reducer, {
  mapStateToProps as transactionSearchMapState,
  mapDispatchToProps as transactionSearchMapDispatch,
} from "./TransactionSearchPage.state";

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: transactionSearchMapState,
    mapDispatchToProps: transactionSearchMapDispatch,
  },
  {
    forms: {
      criteriaForm: {
        ...CriteriaForm,
        actionType: "TRANSACTION_SEARCH_CRITERIA_FORM_ACTION",
      },
      filtersForm: {
        ...FiltersForm,
        actionType: "TRANSACTION_SEARCH_FILTERS_FORM_ACTION",
      },
    },
  },
  "transactionSearch"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };

export default connect(mapStateToProps, mapDispatchToProps)(TransactionSearchPage);
